"use strict";
;
(async function () {
    const containerElement = document.getElementById("bnr-bundle-components");
    const data = await getData(containerElement);
    console.log("data", data);
    if (!data)
        return;
    const { components, vehicles } = data;
    renderComponents(containerElement, components, vehicles);
})();
function renderComponents(containerElement, components, vehicles) {
    console.log("vehicles", vehicles);
    const content = /* html */ `
  
    <h3>Kit Components</h3>
    <ul class="bundle-components" role="list">
      ${components
        .map((component) => {
        const { title, image, sku, handle, quantity, price } = component;
        return /* html */ `<li class="bundle-component">
        <a class="product-link" href="/products/${handle}">
          <img
            class="product-image"
            src="${image}"
            alt="${title}"
            width="64"
            height="64"
            loading="lazy"
          />

          <div class="product-main">
            <h4 class="product-name">${title}</h4>
            <div class="product-meta">
              <span class="product-sku" aria-label="Stock keeping unit">SKU: ${sku}</span>
            </div>
          </div>

          <div class="product-quantity" aria-label="Quantity">
            <span class="quantity-badge" aria-hidden="true">×${quantity}</span>
            <span class="visually-hidden">Quantity: ${quantity}</span>
          </div>

          <div class="product-prices">
            <div class="unit-price" aria-label="Unit price">$${price}</div>
          </div>
        </a>
      </li>`;
    })
        .join("")}
    </ul>

  `;
    containerElement.innerHTML = ""; // Clear any loading text
    containerElement.innerHTML = content;
}
function getData(containerElement) {
    if (!containerElement) {
        console.error("Container element not found");
        return;
    }
    const productGid = containerElement.dataset.productGid;
    console.log("Product GID:", productGid);
    if (!productGid) {
        console.error("Product GID is missing");
        containerElement.innerHTML = "<p>Error: Product ID not found.</p>";
        return;
    }
    const storefrontApiToken = "ecbbf53ca75d6df11c96dd3da02cdc8e"; // Replace with your actual token; consider moving to settings
    const storefrontApiVersion = "2025-10";
    const graphQLQuery = `
      query Prod($id: ID!) {
        product(id: $id) {
          metafield(namespace: "custom", key: "matching_vehicles") {
            value
          }
          variants(first: 1) {
            nodes {
              components(first: 10) {
                nodes {
                  quantity
                  productVariant {
                    sku
                    price {
                      amount
                      currencyCode
                    }
                    product {
                      handle
                      title
                      images(first: 1) {
                        nodes {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;
    console.log("Fetching bundle components...");
    return fetch(`/api/${storefrontApiVersion}/graphql.json`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": storefrontApiToken,
        },
        body: JSON.stringify({
            query: graphQLQuery,
            variables: { id: `gid://shopify/Product/${productGid}` }, // productGid is already the full GID from {{ product.id }}
        }),
    })
        .then((response) => {
        console.log("HTTP Response Status:", response.status); // Debug: Check for 200, 401, etc.
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
    })
        .then(({ data, errors }) => {
        console.log("Full Storefront API Response:", { data, errors }); // Debug: Full output like in GraphiQL
        if (errors) {
            containerElement.innerHTML =
                "<p>Error loading components: See console for details.</p>";
            console.error("GraphQL Errors:", errors);
            return;
        }
        if (!data.product) {
            containerElement.innerHTML =
                "<p>Product not found. Ensure it's published to the Online Store channel.</p>";
            console.error("Product is null. GID used:", productGid);
            return;
        }
        const variant = data.product.variants.nodes[0];
        if (!variant) {
            containerElement.innerHTML =
                "<p>No variants found for this product.</p>";
            console.error("No variants in response");
            return;
        }
        if (!variant.components?.nodes?.length) {
            containerElement.innerHTML =
                "<p>This product is not a bundle or has no components.</p>";
            console.log("Not a bundle or no components:", variant);
            return;
        }
        const vehicles = JSON.parse(data.product.metafield.value);
        console.log("vehicles", vehicles);
        const components = variant.components.nodes.map(({ quantity, productVariant: { sku, price: { amount }, product: { handle, title, images }, }, }) => {
            const image = images.nodes[0].url;
            return {
                title,
                image,
                sku,
                handle,
                quantity,
                price: amount,
            };
        });
        return { components, vehicles };
    })
        .catch((error) => {
        console.error("Fetch Error:", error);
        containerElement.innerHTML = "<p>Failed to load bundle components.</p>";
    });
}
